<template>
  <div class="editDrug column-me">
    <div class="row-me" v-if="isEdit">
      <div class="column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">药品信息</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="column-me row-center margin-left50" @click="clickTab(1)" v-if="false">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">批次信息</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="column-me row-center margin-left50" @click="clickTab(2)" v-if="false">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">进销存清单</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
    </div>
    <div class="line-grey-heng margin-bottom20" v-if="isEdit"></div>

    <!--药品信息-->
    <div class="flex1 overflow-auto column-me" v-show="tabIndex===0">
      <div class="flex1 overflow-auto">
        <div class="row-me row-center">
          <div class="row-me row-center">
            <div class="left-div"><span class="red-star">*</span>药品名称：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.name"
                        :class="{'red-border':showRedBorder&&this.$method.isEmpty(drugItem.name)}"
                        maxlength="30"></el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="left-div"><span class="red-star">*</span>药品编码：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.sn"
                        :class="{'red-border':showRedBorder&&this.$method.isEmpty(drugItem.sn)}"
                        maxlength="30"></el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="row-me row-center">
            <div class="left-div">品质规格：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.spec"></el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="left-div">包装规格：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.packageSpec"></el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="row-me row-center">
            <div class="left-div">拼音检索：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable
                        v-model="drugItem.pyName"></el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="left-div">产地：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" clearable
                        v-model="drugItem.productAddress"></el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="row-me row-center">
            <div class="left-div"><span class="red-star">*</span>所在库房：</div>
            <div class="width300">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable multiple
                         v-model="drugItem.pharmacyIdShow"
                         :class="{'red-border':showRedBorder&&(this.$method.isEmpty(drugItem.pharmacyIdShow)||drugItem.pharmacyIdShow.length===0)}">
                <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="left-div">状态：</div>
            <el-radio-group v-model="drugItem.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="row-me row-center">
            <div class="left-div"><span class="red-star">*</span>常规剂型零售价：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" type="number" min="0"
                        v-model="drugItem.normalPrice"
                        :class="{'red-border':showRedBorder&&this.$method.isEmpty(drugItem.normalPrice)}"
                        @input="drugItem.normalPrice=$method.checkInput(drugItem.normalPrice,3)">
              </el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="left-div"><span class="red-star">*</span>颗粒剂型零售价：</div>
            <div class="width300">
              <el-input placeholder="请输入" style="width: 100%;" type="number" min="0"
                        v-model="drugItem.granulePrice"
                        :class="{'red-border':showRedBorder&&this.$method.isEmpty(drugItem.granulePrice)}"
                        @input="drugItem.granulePrice=$method.checkInput(drugItem.granulePrice,3)">
              </el-input>
            </div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div class="left-div"><span class="red-star">*</span>单位信息：</div>
          <div class="column-me flex1">
            <div class="item-unit column-me column-center" v-for="(item,index) in unitArray" :key="index">
              <div class="row-me row-center">
                <div class="text-grey">单位：</div>
                <div>{{ item.name }}</div>
                <div class="text-grey margin-left200">拆装比例：</div>
                <div>{{ item.proportionNumerator }}:{{ item.proportionDenominator }}</div>
                <div class="flex1"></div>
                <div class="btn-blue width90 btn-height32" @click="editUnit(item,index)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  修改
                </div>
              </div>
              <div class="row-me row-center margin-top10">
                <div class="text-grey">单位类型：</div>
                <el-checkbox v-model="item.base" label="基本单位" disabled></el-checkbox>
                <el-checkbox v-model="item.stock" label="库存单位" disabled></el-checkbox>
                <el-checkbox v-model="item.sales" label="销售单位" disabled></el-checkbox>
                <el-checkbox v-model="item.dosage" label="用量单位" disabled></el-checkbox>
                <div class="flex1"></div>
                <div class="btn-grey width90 btn-height32" @click="deleteUnit(index)">
                  <el-icon>
                    <delete/>
                  </el-icon>
                  删除
                </div>
              </div>
            </div>
            <div class="btn-blank width140 btn-height40"
                 :class="{'margin-top15':unitArray.length>0,'red-border':showRedBorder&&(this.$method.isEmpty(unitArray)||unitArray.length===0)}"
                 @click="clickAddUnit">
              <el-icon color="#A9B6C4">
                <plus/>
              </el-icon>
              添加单位
            </div>
          </div>
        </div>
        <div v-if="isEdit">
          <div class="row-me row-center margin-top20">
            <div class="left-div">默认设置：</div>
            <el-radio-group v-model="drugItem.configType">
              <el-radio :label="1">系统设置</el-radio>
              <el-radio :label="2">自定义设置</el-radio>
            </el-radio-group>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-div">药品库存不足</div>
            <div class="width100">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.earlyNum"
                        @input="drugItem.earlyNum=$method.checkInputZero(drugItem.earlyNum,0)"
                        :disabled="drugItem.configType===1"></el-input>
            </div>
            <div class="margin-left10">{{ drugItem.stockUnit }}系统预警提示</div>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-div">药品周转天数小于</div>
            <div class="width100">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.turnoverDay"
                        @input="drugItem.turnoverDay=$method.checkInputZero(drugItem.turnoverDay,0)"
                        :disabled="drugItem.configType===1"></el-input>
            </div>
            <div class="margin-left10">天系统预警提示</div>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-div">周转天数=当前库存/近</div>
            <div class="width100">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="drugItem.averageNum"
                        @input="drugItem.averageNum=$method.checkInputZero(drugItem.averageNum,0)"
                        :disabled="drugItem.configType===1"></el-input>
            </div>
            <div class="margin-left10">天日均销量</div>
          </div>
        </div>
      </div>
      <div class="row-me row-center flex-end1 margin-top20">
        <div class="btn-blank width140 btn-height40" @click="clickCancel">取消</div>
        <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSave">保存</div>
      </div>

      <!-- 修改单位 -->
      <el-dialog :title="unitTitle" v-model="visibleUnit" width="50%" top="10vh" :destroy-on-close="true">
        <div class="column-me padding20">
          <div class="row-me row-center">
            <div><span class="red-star">*</span>单位：</div>
            <div class="width300">
              <el-select placeholder="请选择单位" style="width: 100%;" filterable clearable
                         v-model="selectUnit.name"
                         :class="{'red-border':showRedBorder1&&(selectUnit.name===''||selectUnit.name===null)}">
                <el-option v-for="item in selectUnitArray" :key="item.name" :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-top30">
            <div><span class="red-star">*</span>拆装比例：</div>
            <div class="width300">
              <el-input placeholder="请输入拆装比例" style="width: 100%;" v-model="selectUnit.proportionNumerator"
                        @input="()=>{selectUnit.proportionNumerator = $method.checkInput(selectUnit.proportionNumerator,2)}"
                        :class="{'red-border':showRedBorder1&&(selectUnit.proportionNumerator===''||selectUnit.proportionNumerator===null)}">
              </el-input>
            </div>
            <div class="margin-left20 margin-right20">/</div>
            <div class="width300">
              <el-input placeholder="请输入拆装比例" style="width: 100%;" v-model="selectUnit.proportionDenominator"
                        @input="()=>{selectUnit.proportionDenominator = $method.checkInput(selectUnit.proportionDenominator,2)}"
                        :class="{'red-border':showRedBorder1&&(selectUnit.proportionDenominator===''||selectUnit.proportionDenominator===null)}">
              </el-input>
            </div>
          </div>
          <div class="row-me row-center margin-top30">
            <div><span class="red-star">*</span>单位类型：</div>
            <el-checkbox v-model="selectUnit.base" label="基本单位"></el-checkbox>
            <el-checkbox v-model="selectUnit.stock" label="库存单位"></el-checkbox>
            <el-checkbox v-model="selectUnit.sales" label="销售单位"></el-checkbox>
            <el-checkbox v-model="selectUnit.dosage" label="用量单位"></el-checkbox>
          </div>
          <div class="row-me row-center flex-end1 margin-top200">
            <div class="btn-blank width140 btn-height40" @click="visibleUnit=false">取消</div>
            <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSaveUnit">保存</div>
          </div>
        </div>
      </el-dialog>
    </div>

    <!--批次信息-->
    <div v-show="tabIndex===1">
      <div class="row-me row-center">
        <div class="width180">
          <el-select v-model="selectHouse" placeholder="所在库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="批次" style="width: 100%;" clearable v-model="batchNo1"></el-input>
        </div>
        <div class="width120 margin-left10">
          <el-select placeholder="状态" style="width: 100%;" filterable clearable v-model="selectState">
            <el-option v-for="item in [{id:0,name:'销售中'},{id:1,name:'已售完'}]" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData1" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="batchNo" label="批次" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="供应商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="avaNums" label="剩余库存" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="inStorageTime" label="入库时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="validityTime" label="有效期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="produceTime" label="生产日期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalPrice" label="成本总额" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createBy" label="操作人" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.status === 0 ? '销售中' : scope.row.status === 1 ? '已销售' : '' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange1" :current-page.sync="pageNo1"
                       layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>

    </div>

    <!--进销存清单-->
    <div v-show="tabIndex===2">
      <div class="row-me row-center">
        <div class="width300">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          value-format="YYYY-MM-DD" style="width: 100%;" clearable v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="批次" style="width: 100%;" clearable v-model="batchNo2"></el-input>
        </div>
        <div class="width160 margin-left10">
          <el-select placeholder="类型" style="width: 100%;" filterable clearable v-model="selectType">
            <el-option v-for="(item,index) in typeArray" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData2" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="createTime" label="时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="类型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="batchNo" label="批次" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="validityTime" label="有效期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="salePrice" label="销售价" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nums" label="原始数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="changeNums" label="变更数量" align="center" show-overflow-tooltip>
            <template #default="scope">
              <div class="row-me center-all">
                <span>{{ scope.row.changeNums }}</span>
                <el-tooltip class="item" effect="dark" content="该入库单的入库数量已被修改，请在入库单中查看修改记录"
                            placement="top">
                  <img src="../../assets/img/i.png" class="img20 margin-left10 pointer">
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="costTotalPrice" label="变更总成本" align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="saleTotalPrice" label="变更总销售价" align="center"
                           show-overflow-tooltip width="150"></el-table-column>
          <el-table-column prop="surplusNums" label="结余数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createBy" label="操作人" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="pageNo2"
                       layout="total, prev, pager, next, jumper" :total="total2">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      tabIndex: 0,
      drugItem: {
        name: '',
        pyName: '',
        normalPrice: '',
        spec: '',
        granulePrice: '',
        pharmacyId: '',//逗号拼接的
        pharmacyIdShow: '',
        status: 1,
      },
      houseArray: [], //库房集合
      unitArray: [], //单位信息集合
      selectUnitArray: [], //单位下拉
      showRedBorder: false,
      visibleUnit: false,
      selectUnit: {
        name: '',
        proportionNumerator: '', //拆装比例分子
        proportionDenominator: '', //拆装比例分母
        base: false,
        stock: false,
        sales: false,
        dosage: false,
      },
      selectUnitCopy: {}, //复制一份用于重置
      showRedBorder1: false,
      unitUpdateIndex: -1, //修改单位的坐标
      unitTitle: '', //单位标题
      tableData1: [],//批次信息
      tableData2: [],//进销存清单
      pageNo1: 1,
      total1: 0,
      pageNo2: 1,
      total2: 0,
      batchNo1: '',
      batchNo2: '',
      selectHouse: '',
      selectState: '',
      selectDate: [],
      selectType: '',
      typeArray: [],
      isEdit: false,//是否是编辑
    }
  },
  // html加载完成之前
  created() {
    let typeStr = '调拨入库、调拨出库、审方出库、退药入库、修正入库、盘亏出库、盘盈入库、手动入库选择的入库类型、手动出库选择的出库类型'
    this.typeArray = typeStr.split('、')
    this.getHouseList()
    this.getUnitList()
    if (this.id && this.id !== '' && this.id !== -1) {
      this.isEdit = true
      this.getData()
    } else {
      this.isEdit = false
    }
    this.selectDate = [this.$method.getNowDate(), this.$method.getNowDate()]
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickTab(index) {
      this.tabIndex = index
      if (this.tabIndex !== 0) {
        this.clickSearch()
      }
    },
    //修改单位
    editUnit(item, index) {
      this.unitTitle = '修改单位'
      this.selectUnit = this.$method.deepClone(item)
      this.selectUnitCopy = this.$method.deepClone(item)
      this.unitUpdateIndex = index
      this.visibleUnit = true
    },
    //删除单位
    deleteUnit(index) {
      this.unitArray.splice(index, 1)
    },
    //添加单位
    clickAddUnit() {
      this.unitTitle = '添加单位'
      this.unitUpdateIndex = -1
      this.selectUnit = {
        name: '',
        proportionNumerator: '', //拆装比例分子
        proportionDenominator: '', //拆装比例分母
        base: false,
        stock: false,
        sales: false,
        dosage: false,
      }
      this.showRedBorder1 = false
      this.visibleUnit = true
    },
    //保存单位
    clickSaveUnit() {
      if (this.selectUnit.name === '' || this.selectUnit.name === null || this.selectUnit
          .proportionDenominator === '' || this.selectUnit.proportionDenominator === null || this.selectUnit
          .proportionNumerator === '' || this.selectUnit.proportionNumerator === null) {
        this.showRedBorder1 = true
        return
      }
      if (Number(this.selectUnit.proportionNumerator) > Number(this.selectUnit.proportionDenominator)) {
        this.$message.error('分母应该大于等于分子')
        return;
      }
      if (!this.selectUnit.base && !this.selectUnit.stock && !this.selectUnit.sales && !this.selectUnit.dosage) {
        this.$message.error('请选择单位类型')
        return
      }
      //判断除库存单位，其它单位只能选择一次
      let copyUnitArray = this.unitArray.concat()
      if (this.unitUpdateIndex != -1) {
        copyUnitArray.splice(this.unitUpdateIndex, 1)
      }
      for (let i = 0; i < copyUnitArray.length; i++) {
        let obj = copyUnitArray[i]
        if ((this.selectUnit.base && obj.base) || (this.selectUnit.sales && obj.sales) || (this.selectUnit
            .dosage && obj.dosage)) {
          this.$message.error('单位重复添加，请重新选择')
          return
        }
      }
      if (this.unitUpdateIndex == -1) {
        this.unitArray.push(this.selectUnit)
      } else {
        this.unitArray.splice(this.unitUpdateIndex, 1, this.selectUnit);
      }
      this.visibleUnit = false
    },
    //取消
    clickCancel() {
      this.bus.$emit('drugAddSuccess')
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.drugItem.name) || this.$method.isEmpty(this.drugItem.sn) || this.$method.isEmpty(this.drugItem.normalPrice)
          || this.$method.isEmpty(this.drugItem.granulePrice) || this.$method.isEmpty(this.drugItem.pharmacyIdShow)
          || this.drugItem.pharmacyIdShow.length === 0 || this.$method.isEmpty(this.unitArray)
          || this.unitArray.length === 0) {
        this.showRedBorder = true
        return
      }
      //判断单位类型必须全添加
      let hadUnit1 = false
      let hadUnit2 = false
      let hadUnit3 = false
      let hadUnit4 = false
      for (let i = 0; i < this.unitArray.length; i++) {
        let obj = this.unitArray[i]
        if (obj.base) {
          hadUnit1 = true
        }
        if (obj.stock) {
          hadUnit2 = true
        }
        if (obj.sales) {
          hadUnit3 = true
        }
        if (obj.dosage) {
          hadUnit4 = true
        }
      }
      let tips = ''
      if (!hadUnit1) {
        tips += '【基本单位】'
      }
      if (!hadUnit2) {
        tips += '【库存单位】'
      }
      if (!hadUnit3) {
        tips += '【销售单位】'
      }
      if (!hadUnit4) {
        tips += '【用量单位】'
      }
      if (tips !== '') {
        this.$message.error(tips + '没有添加')
        return
      }
      if (this.isEdit) {
        if (this.$method.isEmpty(this.drugItem.configType)) {
          this.$message.error("请选择默认设置")
          return;
        }
        if (this.$method.isEmpty(this.drugItem.earlyNum)) {
          this.$message.error("请输入库存不足预警数量")
          return;
        }
        if (this.$method.isEmpty(this.drugItem.turnoverDay)) {
          this.$message.error("请输入预警周转天数")
          return;
        }
        if (this.$method.isEmpty(this.drugItem.averageNum)) {
          this.$message.error("请输入日均销量的天数")
          return;
        }
      }
      //======================
      this.drugItem.units = this.unitArray
      this.drugItem.type = 0 //药品类型 0中药 1 中医外治
      //处理库房多选
      this.drugItem.pharmacyId = this.drugItem.pharmacyIdShow.join(",")
      this.$postRequest('/admin/drug/update', this.drugItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('drugAddSuccess')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取单位列表
    getUnitList() {
      this.$getRequest('/admin/drug/listBaseUnit', {}).then((res) => {
        if (res) {
          this.selectUnitArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/drug/get/' + this.id, {}).then((res) => {
        if (res) {
          if (res.data.pharmacyId) {
            let arr = res.data.pharmacyId.split(',')
            res.data.pharmacyIdShow = arr.map(item => {
              return Number(item)
            })
          }
          if (this.$method.isEmpty(res.data.configType)) {
            res.data.configType = 1//默认系统设置
          }
          //设置库存单位
          for (let unit of res.data.units) {
            if (unit.stock) {
              res.data.stockUnit = unit.name
            }
          }
          this.drugItem = res.data
          this.unitArray = res.data.units
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //搜索
    clickSearch() {
      if (this.tabIndex === 1) {
        this.pageNo1 = 1
        this.getBatchInfo()
      } else if (this.tabIndex === 2) {
        this.pageNo2 = 1
        this.getInOutList()
      }
    },
    //清空
    clickClear() {
      if (this.tabIndex === 1) {
        this.selectHouse = ''
        this.batchNo1 = ''
        this.selectState = ''
      } else if (this.tabIndex === 2) {
        this.selectDate = [this.$method.getNowDate(), this.$method.getNowDate()]
        this.batchNo2 = ''
        this.selectType = ''
      }
      this.clickSearch()
    },
    handleCurrentChange1(pageNo) {
      this.pageNo1 = pageNo
      this.getBatchInfo()
    },
    handleCurrentChange2(pageNo) {
      this.pageNo2 = pageNo
      this.getInOutList()
    },
    //获取批次信息
    getBatchInfo() {
      this.$getRequest('/admin/drug/batchPage', {
        pharmacyId: this.selectHouse,
        batchNo: this.batchNo1,
        status: this.selectState,
        pageNumber: this.pageNo1,
      }).then((res) => {
        if (res) {
          this.total1 = res.data.totalRow
          this.tableData1 = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取进销存清单
    getInOutList() {
      this.$getRequest('/admin/drug/drugInventory', {
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        batchNo: this.batchNo2,
        type: this.selectType,
        pageNumber: this.pageNo2,
      }).then((res) => {
        if (res) {
          this.total2 = res.data.totalRow
          this.tableData2 = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.editDrug {
  overflow: auto;

  .left-div {
    width: 200px;
    text-align: right;
    margin-right: 10px;
  }

  .item-unit {
    height: 100px;
    background: #F5F6F8;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 15px 20px;
  }
}
</style>
